import React from "react"

import Torso from "../model/TorsoBoned.js"

import TorsoMobile from "../model/TorsoBonedMobile.js"
import Rig from "../elements/Rig.js"
import BoxL from "../elements/Box.js"
import BoxR from "../elements/BoxR.js"

import { RectAreaLightUniformsLib } from "three/examples/jsm/lights/RectAreaLightUniformsLib"

RectAreaLightUniformsLib.init()

export default function Home({
  mouse,
  orientation,
  desktopRightHovered,
  desktopLeftHovered,
  mobileLeftClicked,
  mobileRightClicked,
  desktopLeftClicked,
  desktopRightClicked,
}) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  return (
    <>
      <ambientLight intensity={5.0} />
      {isMobile ? (
        <TorsoMobile orientation={orientation} mobileLeftClicked={mobileLeftClicked} mobileRightClicked={mobileRightClicked} />
      ) : (
        <Torso mouse={mouse} desktopLeftClicked={desktopLeftClicked} desktopRightClicked={desktopRightClicked} />
      )}
      <BoxL
        desktopLeftClicked={desktopLeftClicked}
        desktopRightClicked={desktopRightClicked}
        mobileLeftClicked={mobileLeftClicked}
        mobileRightClicked={mobileRightClicked}
        desktopLeftHovered={desktopLeftHovered}
      />
      <BoxR
        desktopLeftClicked={desktopLeftClicked}
        desktopRightClicked={desktopRightClicked}
        mobileLeftClicked={mobileLeftClicked}
        mobileRightClicked={mobileRightClicked}
        desktopRightHovered={desktopRightHovered}
      />
      <Rig
        desktopLeftClicked={desktopLeftClicked}
        desktopRightClicked={desktopRightClicked}
        mobileLeftClicked={mobileLeftClicked}
        mobileRightClicked={mobileRightClicked}
      />
    </>
  )
}
